import config from "@/libs/config";
import { Button } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import Router from "next/router";

export const ConnectBoardReturnButton = () => {
  const onClick = () => {
    Router.push("/connect-biz/redirect-top");
  };

  return (
    <div css={buttonWrapper}>
      <Button type="button" onClick={onClick}>
        {config.CONNECT_BOARD_DISPLAY_NAME}に戻る
      </Button>
    </div>
  );
};

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginBottom: "30px",
  marginTop: "8px",
});
